<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <h1>Stock O/R</h1>
                    <hr>
                    <v-layout>
                        <v-flex xs2>
                            <v-autocomplete :items="itemsRefNo" v-model="refNo" label="Ref no filter:" @change="refNoFilter"></v-autocomplete>
                        </v-flex>
                        <v-flex xs2>
                            <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="startDate" label="Start date:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="startDate" @input="menuStartDate = false" 
                                :max="nowDate" type="date" @change="dateFilter()"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs2 mr-4>
                            <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="endDate" label="End date:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="endDate" @input="menuEndDate = false" 
                                :max="nowDate" type="date" @change="dateFilter()" :min="startDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs2>
                            <v-select :items="itemsWarehouse" v-model="warehouse" label="Warehouse filter:" @change="warehouseFilter"></v-select>
                        </v-flex>
                        <v-flex>
                            <v-btn flat @click="resetFilter"><v-icon>refresh</v-icon>reset</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-data-table :headers="headers" :items="detail" class="elevation-1">
                        <template v-slot:no-data>
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        </template>
                        <template v-slot:items="props">
                            <td>{{props.item.warehouse}}</td>
                            <td>{{props.item.dnNo}}</td>
                            <td>{{props.item.itemCode}}</td>
                            <td>{{props.item.date}}</td>
                            <td>{{props.item.qc}}</td>
                            <td class="text-xs-right">{{props.item.amt.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            nowDate: new Date().toISOString().slice(0,10),
            itemsRefNo: [],
            refNo: '',
            itemsWarehouse: [],
            warehouse: '',
            menuStartDate: false,
            startDate: new Date().toISOString().substr(0,10),
            menuEndDate: false,
            endDate: new Date().toISOString().substr(0,10),

            detail: [],
            cloneDetail: [],
            headers: [
                { text: 'Warehouse', sortable: false, align: 'left' },
                { text: 'RefNo', value: 'dnNo', align: 'left' },
                { text: 'Item code', value: 'itemCode', align: 'left' },
                { text: 'Date', value: 'date', align: 'left' },
                { text: 'Quality control', sortable: false, align: 'left' },
                { text: 'Amount', sortable: false, align: 'right' },
            ],

            showLayout: false,
        }
    },
    methods:{

        // Get the stock that has been sent
        getStock(){
            db.collection("stock").where("dnNo", ">", "").get()
            .then(query=>{
                this.cloneDetail = []
                this.itemsRefNo = []
                this.itemsWarehouse = []
                this.itemsWarehouse.push("")
                this.itemsRefNo.push("")
                query.forEach(doc=>{
                    this.cloneDetail.push(doc.data())
                    this.itemsRefNo.push(doc.data().dnNo)
                    this.itemsWarehouse.push(doc.data().warehouse)
                })
                this.detail = this.cloneDetail
            })
        },

        // Filter by ref no
        refNoFilter(){
            this.detail = this.cloneDetail.filter(rec=>this.refNo == rec.dnNo.slice(0,this.refNo.length))
            this.startDate = new Date().toISOString().substr(0,10)
            this.endDate = new Date().toISOString().substr(0,10)
            this.warehouse = ''
        },

        // Filter by start date and end date
        dateFilter(){
            if(this.refNo == ''){
                this.detail = this.cloneDetail.filter(rec=>rec.date >= this.startDate && rec.date <= this.endDate)
            }
            else{
                this.detail = this.cloneDetail.filter(rec=>this.refNo == rec.dnNo && rec.date >= this.startDate && rec.date <= this.endDate)
            }
        },

        // Filter by warehouse
        warehouseFilter(){
            this.refNo = ''
            this.startDate = new Date().toISOString().substr(0,10)
            this.endDate = new Date().toISOString().substr(0,10)
            this.detail = this.cloneDetail.filter(rec=>this.warehouse == rec.warehouse.slice(0,this.warehouse.length))
        },

        // Reset filter to the default
        resetFilter(){
            this.refNo = ''
            this.startDate = new Date().toISOString().substr(0,10)
            this.endDate = new Date().toISOString().substr(0,10)
            this.warehouse = ''
            this.detail = this.cloneDetail
        }
    },
    mounted(){
        this.getStock()
    }
}
</script>